import { Tag01 } from "@untitledui/icons";
import { useState } from "react";
import { Button } from "@/components/base/buttons/button";
import { type BulkTagCreator, BulkTagModal } from "@/pages/creator-tags/bulk-tag-modal";

/**
 * "Tag" action for the multi-select action bar: opens the bulk-apply modal for
 * the selected creators. Any selection size is supported (the server chunks the
 * assignment), so the action is bounded only by the caller's `isDisabled`.
 */
export const BulkTagButton = ({
  creators,
  onApplied,
  isDisabled,
}: {
  creators: BulkTagCreator[];
  onApplied?: () => void;
  isDisabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button iconLeading={Tag01} isDisabled={isDisabled} onClick={() => setOpen(true)}>
        Tag
      </Button>
      <BulkTagModal creators={creators} open={open} onOpenChange={setOpen} onApplied={onApplied} />
    </>
  );
};
